module.exports = __webpack_public_path__ + "static/media/p11_data.4caf5b16.txt";